<mat-dialog-content class="confirmation py-5">
  <div class="mat-dialog-body">
    <ng-lottie class="d-flex justify-content-center m-auto py-5" [options]="options" width="200px"></ng-lottie>
    <h3 class="text-center subtitle-form">{{'swalMsg.aiMonitoringInProgress' | translate}}</h3>
    <p class="text-center">
      {{'swalMsg.pleaseWaitAiProcessingMonitoringResults' | translate}}
      {{'swalMsg.doNotRefreshOrLeavePage' | translate}}
    </p>
  </div>
</mat-dialog-content>
